// extracted by mini-css-extract-plugin
export var button = "_33-1";
export var featuredLink = "_33-4";
export var spinner = "_33-2";
export var spinnerContainer = "_33-3";
export var text = "_33-0";